/**
 * Madelyn Muse - Theme JavaScript
 * Mobile menu, quantity controls, product thumbnails, variant selection,
 * AJAX cart (auto-update), AJAX add to cart.
 */

document.addEventListener("DOMContentLoaded", function () {
  // ---- Mobile Menu ----
  const menuToggle = document.getElementById("mobile-menu-toggle");
  const mobileMenu = document.getElementById("mobile-menu");

  const HAMBURGER_SVG = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>`;

  const CLOSE_SVG = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>`;

  function openMobileMenu() {
    mobileMenu.classList.add("is-open");
    menuToggle.setAttribute("aria-expanded", "true");
    mobileMenu.setAttribute("aria-hidden", "false");
    menuToggle.innerHTML = CLOSE_SVG;
    document.body.style.overflow = "hidden";
    mobileMenu.addEventListener("keydown", trapFocus);
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove("is-open");
    menuToggle.setAttribute("aria-expanded", "false");
    mobileMenu.setAttribute("aria-hidden", "true");
    menuToggle.innerHTML = HAMBURGER_SVG;
    document.body.style.overflow = "";
    mobileMenu.removeEventListener("keydown", trapFocus);
    menuToggle.focus();
  }

  function trapFocus(e) {
    if (e.key !== "Tab") return;

    const focusable = mobileMenu.querySelectorAll(
      'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      var isOpen = mobileMenu.classList.contains("is-open");
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        closeMobileMenu();
      }
    });
  }

  // ---- Helpers ----
  function getProductData() {
    var el = document.getElementById("product-json");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency || window.Shopify?.currency?.active || "USD" }).format(cents / 100);
  }

  // ---- AJAX Cart Helper ----
  function updateCartItem(lineKey, quantity, lineItem) {
    if (lineItem) lineItem.style.opacity = "0.5";

    fetch((window.routes?.cart_change_url || "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart update failed");
        return res.json();
      })
      .then(function (cart) {
        // Update header cart count
        var cartCount = document.querySelector(".site-header__cart-count");
        if (cartCount) cartCount.textContent = cart.item_count;
        document.querySelectorAll("[data-mm-cart-count]").forEach(function (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
          count.closest("a").setAttribute("aria-label", "Bag, " + cart.item_count + " items");
        });

        // Update subtotal
        var subtotal = document.querySelector("[data-cart-total]");
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);

        if (quantity === 0 && lineItem) {
          // Animate out and remove
          lineItem.style.transition = "opacity 0.3s, transform 0.3s";
          lineItem.style.opacity = "0";
          lineItem.style.transform = "translateX(-20px)";
          setTimeout(function () {
            lineItem.remove();
            // If cart is now empty, show empty state
            if (cart.item_count === 0) {
              var cartSection = document.querySelector(".main-cart__inner");
              if (cartSection) {
                cartSection.innerHTML =
                  '<h1 class="main-cart__title">Your Cart</h1>' +
                  '<div class="main-cart__empty">' +
                  '<p class="main-cart__empty-text">Your cart is empty ☁️</p>' +
                  '<a href="/collections/all" class="btn btn--primary">Continue Shopping</a>' +
                  "</div>";
              }
            }
          }, 300);
        } else if (lineItem) {
          lineItem.style.opacity = "1";
          // Update line total
          var updatedItem = cart.items.find(function (item) {
            return String(item.key) === String(lineKey);
          });
          if (updatedItem) {
            var lineTotal = lineItem.querySelector(".cart-item__line-price");
            if (lineTotal) lineTotal.textContent = formatMoney(updatedItem.final_line_price, cart.currency);
            // Sync input value with server response
            var input = lineItem.querySelector(".cart-qty__input");
            if (input) input.value = updatedItem.quantity;
          }
        }
      })
      .catch(function (err) {
        console.error("Cart update error:", err);
        if (lineItem) lineItem.style.opacity = "1";
        var error = document.querySelector("[data-mm-cart-error]");
        if (error) { error.textContent = "We couldn’t update your bag. Please refresh and try again."; error.hidden = false; }
      });
  }

  // ---- Click Event Delegation ----
  document.body.addEventListener("click", function (e) {
    // Product page quantity buttons
    var qtyBtn = e.target.closest(".main-product__qty-btn");
    if (qtyBtn) {
      var input = qtyBtn.parentElement.querySelector(".main-product__qty-input");
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      var action = qtyBtn.getAttribute("data-action");

      if (action === "increase") {
        value++;
      } else if (action === "decrease" && value > 1) {
        value--;
      }

      input.value = value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    // Product thumbnail gallery
    var thumb = e.target.closest(".main-product__thumbnail");
    if (thumb) {
      var imageUrl = thumb.getAttribute("data-image-url");
      var mainImage = document.getElementById("main-product-image");

      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;

        document.querySelectorAll(".main-product__thumbnail").forEach(function (t) {
          t.classList.remove("main-product__thumbnail--active");
        });
        thumb.classList.add("main-product__thumbnail--active");
      }
      return;
    }

    // Cart quantity buttons (+/-)
    var cartQtyBtn = e.target.closest(".cart-qty__btn");
    if (cartQtyBtn) {
      var input = cartQtyBtn.parentElement.querySelector(".cart-qty__input");
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      var action = cartQtyBtn.getAttribute("data-action");
      var lineKey = input.getAttribute("data-line-key");
      var lineItem = cartQtyBtn.closest(".cart-item");

      if (action === "increase") {
        value++;
      } else if (action === "decrease") {
        value = Math.max(0, value - 1);
      }

      input.value = value;

      if (value === 0) {
        updateCartItem(lineKey, 0, lineItem);
      } else {
        updateCartItem(lineKey, value, lineItem);
      }
      return;
    }

    // Cart remove button
    var removeBtn = e.target.closest(".cart-item__remove");
    if (removeBtn) {
      var lineKey = removeBtn.getAttribute("data-line-key");
      var lineItem = removeBtn.closest(".cart-item");
      updateCartItem(lineKey, 0, lineItem);
      return;
    }
  });

  // ---- Change Event Delegation ----
  document.body.addEventListener("change", function (e) {
    // Variant option inputs
    if (e.target.matches(".main-product__option-input")) {
      var product = getProductData();
      if (!product || !product.variants) return;

      var selectedOptions = [];
      document.querySelectorAll(".main-product__option-input:checked").forEach(function (input) {
        selectedOptions.push(input.value);
      });

      var match = product.variants.find(function (variant) {
        return selectedOptions.every(function (opt, i) {
          return variant.options[i] === opt;
        });
      });

      var idInput = document.querySelector('.main-product__form [name="id"]');
      var currentPrice = document.querySelector(".main-product__current-price");
      var comparePrice = document.querySelector(".main-product__compare-price");
      var addBtn = document.querySelector(".main-product__form [type='submit']");

      if (match) {
        if (idInput) idInput.value = match.id;
        if (currentPrice) currentPrice.textContent = formatMoney(match.price);

        if (comparePrice) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            comparePrice.textContent = formatMoney(match.compare_at_price);
            comparePrice.style.display = "";
          } else {
            comparePrice.textContent = "";
            comparePrice.style.display = "none";
          }
        }

        if (addBtn) {
          if (match.available) {
            addBtn.disabled = false;
            addBtn.textContent = "Add to Cart";
          } else {
            addBtn.disabled = true;
            addBtn.textContent = "Sold Out";
          }
        }
      } else {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = "Unavailable";
        }
      }
      return;
    }

    // Cart quantity manual input change → auto AJAX update
    if (e.target.matches(".cart-qty__input")) {
      var input = e.target;
      var lineKey = input.getAttribute("data-line-key");
      var quantity = parseInt(input.value, 10);
      var lineItem = input.closest(".cart-item");

      if (!lineKey || isNaN(quantity) || quantity < 0) return;
      updateCartItem(lineKey, quantity, lineItem);
    }
  });

  // ---- Waitlist Hero (pre-launch landing) ----
  initWaitlist();

  // ---- CTA Banner coupon reveal / copy ----
  initCtaCoupon();

  // ---- AJAX Add to Cart ----
  var productForm = document.querySelector(".main-product__form");

  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      var submitBtn = productForm.querySelector("[type='submit']");
      var originalText = submitBtn ? submitBtn.textContent : "";

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Adding...";
      }

      var formData = new FormData(productForm);
      var body = {};
      formData.forEach(function (value, key) {
        body[key] = value;
      });

      if (body.quantity) {
        body.quantity = parseInt(body.quantity, 10) || 1;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || "Could not add to cart");
            });
          }
          return res.json();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.textContent = "Added!";
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 2000);
          }

          return fetch("/cart.js");
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var cartCount = document.querySelector(".site-header__cart-count");
          if (cartCount) cartCount.textContent = cart.item_count;
        document.querySelectorAll("[data-mm-cart-count]").forEach(function (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
          count.closest("a").setAttribute("aria-label", "Bag, " + cart.item_count + " items");
        });
        })
        .catch(function (err) {
          console.error("Add to cart error:", err);
          if (submitBtn) {
            submitBtn.textContent = err.message || "Error";
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 2000);
          }
        });
    });
  }

  // ===================================================================
  // Waitlist Hero: per-path carousels, path toggle, Klaviyo capture
  // ===================================================================
  function initWaitlist() {
    var wl = document.querySelector(".wl");
    if (!wl) return;

    var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var KLAVIYO_REVISION = "2026-04-15";

    // ---- Modal open/close ----
    var modal = wl.querySelector("[data-wl-modal]");
    var modalCard = modal ? modal.querySelector(".wl-modal__card") : null;

    function openModal() {
      if (!modal) return;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      // Focus first input
      setTimeout(function () {
        var firstInput = modal.querySelector("input[type='email']");
        if (firstInput) firstInput.focus();
      }, 350);
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    // Open buttons
    wl.querySelectorAll("[data-open-wl-modal]").forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });

    // Close buttons + backdrop
    if (modal) {
      modal.querySelectorAll("[data-close-wl-modal]").forEach(function (el) {
        el.addEventListener("click", closeModal);
      });
      // Escape key
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
      });
    }

    // ---- Carousels (one per path) ----
    var carousels = {};
    wl.querySelectorAll(".wl-carousel").forEach(function (car) {
      var path = car.getAttribute("data-path");
      var slides = Array.prototype.slice.call(car.querySelectorAll(".wl-slide"));
      var dotsWrap = car.querySelector(".wl-carousel__dots");
      var current = 0;
      var timer = null;

      slides.forEach(function (s, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("role", "tab");
        b.setAttribute("aria-label", "Photo " + (i + 1));
        b.setAttribute("aria-selected", i === 0 ? "true" : "false");
        b.addEventListener("click", function () { go(i); restart(); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      function go(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle("is-active", n === current); });
        dots.forEach(function (d, n) { d.setAttribute("aria-selected", n === current ? "true" : "false"); });
      }
      function next() { go(current + 1); }
      function start() { if (REDUCED || slides.length < 2 || timer) return; timer = setInterval(next, 4500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      car.addEventListener("mouseenter", stop);
      car.addEventListener("mouseleave", start);
      car.addEventListener("focusin", stop);
      car.addEventListener("focusout", start);

      var startX = 0;
      car.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
      car.addEventListener("touchend", function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { if (dx < 0) next(); else go(current - 1); restart(); }
      }, { passive: true });

      carousels[path] = { start: start, stop: stop };
    });

    function activateCarousel(path) {
      Object.keys(carousels).forEach(function (p) {
        if (p === path) carousels[p].start(); else carousels[p].stop();
      });
    }

    // ---- Path toggle (Mom / Mini Muse) ----
    var toggleBtns = Array.prototype.slice.call(wl.querySelectorAll(".wl-toggle__btn"));
    var panels = Array.prototype.slice.call(wl.querySelectorAll(".wl-panel"));
    var cars = Array.prototype.slice.call(wl.querySelectorAll(".wl-carousel"));
    var formwrap = wl.querySelector(".wl-formwrap");
    var ctaArea = wl.querySelector(".wl-cta-area");

    // Schema settings for path-switching
    var momSettings = {
      title: wl.querySelector('.wl-panel[data-path="mom"] .wl-h'),
      sub: wl.querySelector('.wl-panel[data-path="mom"] .wl-sub')
    };
    var museSettings = {
      title: wl.querySelector('.wl-panel[data-path="muse"] .wl-h'),
      sub: wl.querySelector('.wl-panel[data-path="muse"] .wl-sub')
    };

    function setPath(path) {
      wl.setAttribute("data-active-path", path);
      toggleBtns.forEach(function (b) {
        var on = b.getAttribute("data-path") === path;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        var on = p.getAttribute("data-path") === path;
        p.classList.toggle("is-shown", on);
        if (on) { p.removeAttribute("hidden"); } else { p.setAttribute("hidden", ""); }
      });
      cars.forEach(function (c) {
        c.classList.toggle("is-shown", c.getAttribute("data-path") === path);
      });

      // Update form labels inside modal
      if (formwrap) {
        var emailLabel = formwrap.querySelector("[data-email-label]");
        var submitLabel = formwrap.querySelector("[data-submit-label]");
        var grownup = formwrap.querySelector("[data-grownup-note]");
        if (emailLabel) emailLabel.textContent = formwrap.getAttribute("data-label-" + path);
        if (submitLabel) submitLabel.textContent = formwrap.getAttribute("data-btn-" + path);
        if (grownup) { if (path === "muse") { grownup.removeAttribute("hidden"); } else { grownup.setAttribute("hidden", ""); } }
      }

      // Update CTA button label
      if (ctaArea) {
        var ctaLabel = ctaArea.querySelector("[data-cta-label]");
        if (ctaLabel) ctaLabel.textContent = ctaArea.getAttribute("data-btn-" + path);
        // Update social proof
        var proof = ctaArea.querySelector("[data-proof]");
        if (proof) proof.textContent = proof.getAttribute("data-proof-" + path);
      }

      // Update modal header
      if (modalCard) {
        var modalTitle = modalCard.querySelector("[data-modal-title]");
        var modalSub = modalCard.querySelector("[data-modal-sub]");
        var srcPanel = path === "muse" ? museSettings : momSettings;
        if (modalTitle && srcPanel.title) modalTitle.innerHTML = srcPanel.title.innerHTML;
        if (modalSub && srcPanel.sub) modalSub.textContent = srcPanel.sub.textContent;
      }

      activateCarousel(path);
    }

    toggleBtns.forEach(function (b) {
      b.addEventListener("click", function () { setPath(b.getAttribute("data-path")); });
    });

    activateCarousel(wl.getAttribute("data-active-path") || "mom");

    // Auto-open modal if server rendered a success state (Shopify form fallback)
    if (wl.querySelector(".wl-success")) {
      openModal();
    }

    // ---- Capture form: Klaviyo client-side subscribe (progressive enhancement) ----
    var klKey = (wl.getAttribute("data-kl-key") || "").trim();
    var klList = (wl.getAttribute("data-kl-list") || "").trim();
    var form = wl.querySelector(".wl-form");

    function toE164(raw) {
      if (!raw) return null;
      var v = raw.replace(/[^\d+]/g, "");
      if (v.charAt(0) === "+") return v.length >= 11 ? v : null;
      var d = v.replace(/\D/g, "");
      if (d.length === 10) return "+1" + d;
      if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
      return null;
    }

    function showSuccess() {
      if (!formwrap) return;
      var t = formwrap.getAttribute("data-success-title") || "You're in!";
      var p = formwrap.getAttribute("data-success-text") || "";
      formwrap.innerHTML =
        '<div class="wl-success" role="status"><span class="wl-success__mark">✿</span><h3></h3><p></p></div>';
      formwrap.querySelector("h3").textContent = t;
      formwrap.querySelector("p").textContent = p;
    }

    // Only intercept when Klaviyo is configured; otherwise the native Shopify
    // customer form submits and the server renders the success state on reload.
    if (form && klKey && klList) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var emailEl = form.querySelector('input[name="contact[email]"]');
        var phoneEl = form.querySelector('input[name="phone"]');
        var smsEl = form.querySelector('input[name="sms_consent"]');
        var nameEl = form.querySelector('input[name="contact[first_name]"]');
        var bMonthEl = form.querySelector('select[name="mini_muse_birth_month"]');
        var bDayEl = form.querySelector('select[name="mini_muse_birth_day"]');
        var btn = form.querySelector(".wl-submit");
        var errEl = form.querySelector(".wl-error");
        var email = emailEl ? emailEl.value.trim() : "";
        if (!email) return;
        var phone = phoneEl ? toE164(phoneEl.value) : null;
        var wantSms = smsEl ? smsEl.checked : false;
        var firstName = nameEl ? nameEl.value.trim() : "";
        var bMonth = bMonthEl ? bMonthEl.value : "";
        var bDay = bDayEl ? bDayEl.value : "";
        var path = wl.getAttribute("data-active-path") || "mom";

        if (errEl) { errEl.hidden = true; errEl.textContent = ""; }
        var orig = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Saving..."; }

        var subs = { email: { marketing: { consent: "SUBSCRIBED" } } };
        if (phone && wantSms) subs.sms = { marketing: { consent: "SUBSCRIBED" } };

        var attrs = {
          email: email,
          properties: { waitlist_path: path, waitlist_offer: "founding-gift-box" },
          subscriptions: subs
        };
        if (phone) attrs.phone_number = phone;
        if (firstName) attrs.first_name = firstName;
        if (bMonth && bDay) {
          // Birthday flows in Klaviyo trigger off a Date property. We collect only
          // day + month (kids brand: no birth year stored), so we stamp a fixed
          // leap-year placeholder (2000) — the yearly flow fires on the right month/day.
          var pad2 = function (n) { return String(n).length < 2 ? "0" + n : String(n); };
          attrs.properties.mini_muse_birthday = "2000-" + pad2(bMonth) + "-" + pad2(bDay);
        }

        var payload = {
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Waitlist (" + path + ")",
              profile: { data: { type: "profile", attributes: attrs } }
            },
            relationships: { list: { data: { type: "list", id: klList } } }
          }
        };

        fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(klKey), {
          method: "POST",
          headers: { "Content-Type": "application/vnd.api+json", revision: KLAVIYO_REVISION },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (res.status === 202 || res.ok) { showSuccess(); return; }
            return res.text().then(function (t) { throw new Error(t || "Subscribe failed"); });
          })
          .catch(function (err) {
            console.error("Klaviyo subscribe error:", err);
            if (btn) { btn.disabled = false; btn.textContent = orig; }
            if (errEl) { errEl.hidden = false; errEl.textContent = "Something went wrong. Please try again."; }
          });
      });
    }
  }

  // ===================================================================
  // CTA Banner: reveal coupon code and copy to clipboard
  // ===================================================================
  function initCtaCoupon() {
    document.querySelectorAll(".cta-coupon").forEach(function (wrap) {
      var btn = wrap.querySelector(".cta-coupon__btn");
      var hint = wrap.querySelector(".cta-coupon__hint");
      var code = wrap.getAttribute("data-coupon");
      if (!btn || !code) return;
      var revealed = false;
      btn.addEventListener("click", function () {
        if (!revealed) { btn.textContent = code; btn.classList.add("is-revealed"); revealed = true; }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            if (hint) hint.textContent = "Copied!";
          }).catch(function () { if (hint) hint.textContent = "Copy: " + code; });
        } else if (hint) {
          hint.textContent = "Copy: " + code;
        }
      });
    });
  }
});
